import React, { useEffect, useState } from "react";
import { Doughnut } from "react-chartjs-2";
import axios from "axios";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { baseurl } from "../../Baseurl";
import axiosInstance from "../../api/axiosInstance";

// Draws the raw value at the center of each doughnut slice, always visible (no hover needed).
const sliceValueLabelsPlugin = {
  id: "sliceValueLabels",
  afterDraw(chart) {
    const { ctx } = chart;
    chart.data.datasets.forEach((dataset, datasetIndex) => {
      const meta = chart.getDatasetMeta(datasetIndex);
      if (meta.hidden) return;
      meta.data.forEach((arc, index) => {
        const value = dataset.data[index];
        if (!value) return;
        const { x, y } = arc.tooltipPosition();
        ctx.save();
        ctx.font = "bold 15px sans-serif";
        ctx.textAlign = "center";
        ctx.textBaseline = "middle";
        ctx.lineWidth = 3;
        ctx.strokeStyle = "rgba(0,0,0,0.75)";
        ctx.strokeText(value, x, y);
        ctx.fillStyle = "#fff";
        ctx.fillText(value, x, y);
        ctx.restore();
      });
    });
  },
};

ChartJS.register(ArcElement, Tooltip, Legend);
export default function Agechart() {
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const getFontSize = () => {
    if (windowWidth > 3000) return 24;
    if (windowWidth > 2500) return 19;
    if (windowWidth >= 2000) return 15;
    if (windowWidth >= 1600) return 13;
    return 11;
  };
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const [chartData, setChartData] = useState({
    labels: ["Loading..."],
    datasets: [
      {
        label: "Patients",
        data: [0],
        backgroundColor: [
          "#3f75c7",
          "#ffc107",
          "#28a745",
          "#6f42c1",
          "#17a2b8",
        ],
        borderColor: "#fff",
        borderWidth: 2,
      },
    ],
  });
  const [loading, setLoading] = useState(true);
  const fetchChartData = async () => {
    try {
      const response = await axiosInstance.get(
        `dashboard/patients/pie_chart`
      );

      if (response.status === 200 && response.data.success) {
        const data = response.data.data || [];

        if (data.length > 0) {
          const filteredData = data.filter((item) => {
            const lbl = item.label?.toLowerCase();
            return lbl === "female patients" || lbl === "male patients";
          });
          setChartData({
            labels: filteredData.map((item) => item.label || "Unknown"),
            datasets: [
              {
                label: "Patients",
                data: filteredData.map((item) => item.value || 0),
                backgroundColor: ["#4680ff", "#ff4c97ff"],
                borderColor: "#fff",
                borderWidth: 2,
              },
            ],
          });
        } else {
          console.warn("API returned empty data, keeping defaults.");
        }
      }
    } catch (err) {
      console.error("API Error:", err);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchChartData();
  }, []);
  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          font: {
            size: getFontSize(), // ✅ Apply dynamic font size here
          },
          generateLabels: (chart) => {
            const { labels, datasets } = chart.data;
            const values = datasets[0]?.data || [];
            const colors = datasets[0]?.backgroundColor || [];
            return labels.map((label, i) => ({
              text: `${label}: ${values[i] ?? 0}`,
              fillStyle: colors[i],
              strokeStyle: colors[i],
              index: i,
            }));
          },
        },
      },
    },
    cutout: "60%",
  };
  const getChartHeight = () => {
    if (windowWidth > 3000) return 500;
    if (windowWidth > 2500) return 380;
    if (windowWidth >= 2000) return 320;
    if (windowWidth >= 1600) return 270;
    return 250;
  };
  return (
    <div className="row">
      <div className="col-12">
        {loading ? (
          <p>Loading chart...</p>
        ) : (
          <div
            style={{ position: "relative", width: "100%", height: getChartHeight(), margin: "auto" }}
            className="d-flex justify-content-center mt-3"
          >
            <Doughnut data={chartData} options={options} plugins={[sliceValueLabelsPlugin]} key={windowWidth} />
          </div>
        )}
      </div>
    </div>
  );
}
